import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';

import Auth0RolesPanelContext from '@totem/components/administration/auth0/roles/panel/Auth0RolesPanelContext';
import { IBAuth0Role } from '@totem/components/administration/auth0/roles/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';

const EMPTY_ID = '000000000000000000000000';

const displayRef = (id?: string, name?: string) => {
  if (!id || id === EMPTY_ID || !name) return '—';
  return name;
};

const Auth0RolesPanelTable = () => {
  const { loading, roles, buildingId, buildingName } = useContext(
    Auth0RolesPanelContext,
  );

  const fromParam =
    buildingId && buildingName
      ? `?from=building:${buildingId}:${buildingName}`
      : '';

  const columns: ColumnsType<IBAuth0Role> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (
        <Link to={`/dashboard/remoteAccess/auth0role/${record.id}${fromParam}`}>
          {record.name}
        </Link>
      ),
      sorter: (aRow, bRow) => aRow.name.localeCompare(bRow.name),
    },
    {
      title: 'Description',
      key: 'description',
      render: (_, record) => record.role?.description ?? '',
    },
    {
      title: 'Control System',
      key: 'controlSystem',
      render: (_, record) =>
        displayRef(
          record.hierarchyReference?.controlSystem?.id,
          record.hierarchyReference?.controlSystem?.name,
        ),
      sorter: (aRow, bRow) =>
        (aRow.hierarchyReference?.controlSystem?.name ?? '').localeCompare(
          bRow.hierarchyReference?.controlSystem?.name ?? '',
        ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (sts: string) => (
        <Tag color={sts === 'Active' ? 'success' : 'default'}>{sts}</Tag>
      ),
      sorter: (aRow, bRow) => aRow.status.localeCompare(bRow.status),
    },
  ];

  return (
    <IBTable<IBAuth0Role>
      showSorterTooltip
      columns={columns}
      dataSource={roles}
      loading={loading}
      rowKey="id"
      pagination={{ defaultPageSize: 10, showSizeChanger: true }}
    />
  );
};

export default Auth0RolesPanelTable;
